import React, { useEffect, useState } from 'react';
import { View, TouchableOpacity, Text, ActivityIndicator } from 'react-native';
import InputDefault from "../../components/Form/InputDefault";
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from "@react-native-async-storage/async-storage";
import RNPickerSelect from "react-native-picker-select";
import { toast } from './../../utils/toast'
import HeaderDefault from '../../components/HeaderDefault';
import api from '../../services/api';

import styles from './styles';

const NewBankAccount = ({ navigation }) => {
    const [bank, setBank] = useState(0);
    const [typeAccount, setTypeAccount] = useState(0);
    const [agency, setAgency] = useState('');
    const [account, setAccount] = useState('');
    const [itemsBanks, setItemsBanks] = useState([]);
    const [accountType, setAccountType] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getBanks();
        getAccountType();
    }, []);

    function getBanks() {
        setIsLoading(true);
        api.get('/banks')
            .then((res) => {
                var banks = [];
                res.data.data.map(item => {
                    banks.push({
                        'label': item.bank,
                        'value': item.id
                    })
                })

                setItemsBanks(banks);
                setIsLoading(false);
            })
            .catch((error) => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    function getAccountType() {
        setIsLoading(true);
        api.get('/bank-account-types')
            .then((res) => {
                var types = [];

                res.data.data.map(item => {
                    types.push({
                        'label': item.name,
                        'value': item.id
                    })
                })

                setAccountType(types);
                setIsLoading(false);
            })
            .catch((error) => {
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    async function saveBank() {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        if (!bank) {
            toast("Selecione um banco.", "#DA1414", 3000);
            return false;
        }

        if (!typeAccount) {
            toast("Selecione um tipo de conta.", "#DA1414", 3000);
            return false;
        }

        if (!agency) {
            toast("Preencha o número da agência.", "#DA1414", 3000);
            return false;
        }

        if (!account) {
            toast("Preencha o número da conta.", "#DA1414", 3000);
            return false;
        }

        setIsLoading(true);
        const data = {
            "bank_id": bank,
            "bank_account_type_id": typeAccount,
            "branch": agency,
            "account": account
        };

        api
            .post('/bank-accounts', data, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${token}`
                }
            })
            .then(() => {
                navigation.goBack();
                setIsLoading(false);
            })
            .catch(() => {
                toast("Houve um erro ao cadastrar, tente novamente mais tarde.", "#DA1414", 3000);
                setIsLoading(false);
            })
    }
    const handleSelect = (value) => {
        setBank(value)
    }
    return (
        <>
            <HeaderDefault title={'Adicionar nova conta'} />

            <View style={styles.container}>
                <View style={{ marginTop: 15, marginBottom: 15 }}>
                    <Text>Selecione o tipo de conta</Text>
                    {
                        accountType.map((el, index) =>
                            <TouchableOpacity key={index} style={{
                                marginTop: 5, borderWidth: 1, borderColor: '#656565', borderRadius: 3, paddingHorizontal: 10, paddingVertical: 10,
                                backgroundColor: el.value === typeAccount ? '#ccc' : '#f1f1f1'
                            }} onPress={() => { setTypeAccount(el.value) }}>
                                <Text style={{ color: el.value === typeAccount ? '#333' : '#222' }}>{el.label}</Text>
                            </TouchableOpacity>)
                    }
                </View>
                <View style={{ marginTop: 20 }}>
                    <Text>Selecione o banco</Text>
                    <RNPickerSelect
                        key={'rnpickselect1'}
                        onValueChange={(value) => handleSelect(value)}
                        placeholder={{
                            label: 'Selecione o banco',
                            value: null,
                        }}
                        items={itemsBanks}
                        //value={bank}
                        style={{
                            inputWeb: {
                                borderRadius: 4,
                                paddingHorizontal: 10,
                                height: 40,
                                marginVertical: 10,
                                color: '#222'
                            }
                        }}
                    />
                </View>

                {/* <RNPickerSelect
                    key={'rnpickselect2'}
                    onValueChange={(value) => {setTypeAccount(value)}}
                    placeholder={{
                        label: 'Selecione o tipo de conta',
                        value: 0,
                    }}
                    items={accountType}
                    value={typeAccount}
                       style={{
                        inputWeb: {
                            borderRadius: 4,
                            paddingHorizontal: 10,
                            height: 40,
                            marginVertical: 10,
                            color: '#222'
                        }
                    }}
                /> */}



                <InputDefault
                    value={agency}
                    onValueChange={(value) => setAgency(value)}
                    placeholder={"Agência"}
                    type={"numeric"}
                />

                <InputDefault
                    value={account}
                    onValueChange={(value) => setAccount(value)}
                    placeholder={"Conta"}
                    type={"numeric"}
                />
                <Text style={styles.titularityText}>
                    * A conta deve ser de sua titularidade (mesmo nome e CPF)
                </Text>
            </View>

            <View style={styles.contentBtn}>
                <TouchableOpacity onPress={saveBank} disabled={isLoading ? true : false}>
                    <LinearGradient
                        start={{ x: -1, y: 0 }}
                        end={{ x: 1, y: 0 }}
                        colors={["#16195B", "#1FBFB5"]}
                        style={styles.btn}
                    >
                        {isLoading ? (
                            <ActivityIndicator color="#1FBFB5" size="small" />
                        ) : (
                            <Text style={styles.textBtn}>ADICIONAR</Text>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        </>
    );
}

export default NewBankAccount;